
import api_list from "@/constant/apiUrl";
import app_config from "@/constant/config";
import { startRequest } from "@/utility/helper/requestHelper";

export const getPressList = async (params:any) => {
  const apiData = {
    url: api_list.press,
    method: "GET",
    params: {
      ...params,
    }
  };

  return startRequest(apiData, app_config.api_static);
};

export const getDetailPress = async (params:any) => {
  const apiData = {
    url: api_list.press + `/${params.id}`,
    method: "GET",
    params: {
      ...params,
    }
  };

  return startRequest(apiData, app_config.api_static);
};